/* mūla-mārga · Coming soon: the line art drawing itself, the letter writing itself, "notify me" per product,
   the craft photos opening on scroll, the launch countdown and calendar file, the brand header, pointer depth and card tilt,
   and the sign-up (a normal form post, so Shopify's spam check runs).
   Motion writes CSS custom properties and only runs while something moves; the load-in is CSS only.
   Reduced motion: everything is shown finished and still, and the forms still work. */
(() => {
  const root = document.querySelector('[data-mm-cs]');
  if (!root) return;
  document.documentElement.classList.remove('no-js');

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

  /* ---------------------------------------------------------- Sign-up */
  const form = root.querySelector('.mm-cs-form');
  const email = form && form.querySelector('input[type="email"]');
  const tagsInput = form && form.querySelector('[data-mm-cs-tags]');
  const errorEl = form && form.querySelector('[data-mm-cs-error]');
  const submit = form && form.querySelector('button[type="submit"]');

  const focusField = () => {
    if (!email) return;
    email.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    window.setTimeout(() => email.focus({ preventScroll: true }), reduce ? 0 : 550);
  };

  const showSuccess = (okEl) => {
    okEl.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    okEl.focus({ preventScroll: true });
  };

  // After a sign-up that reloaded the page, bring the thank-you into view.
  const okAfterReload = root.querySelector('.mm-cs-form > [data-mm-cs-ok]');
  if (okAfterReload) showSuccess(okAfterReload);

  /* ---------------------------------------------------------- Brand header */
  const top = root.querySelector('[data-mm-cs-top]');
  const syncTop = () => {
    if (top) top.classList.toggle('is-stuck', window.scrollY > 4);
  };
  window.addEventListener('scroll', syncTop, { passive: true });
  syncTop();

  /* ---------------------------------------------------------- Countdown */
  const countdown = root.querySelector('[data-mm-cs-countdown]');
  if (countdown) {
    const launch = Date.parse(countdown.dataset.launch);
    const cells = {};
    countdown.querySelectorAll('[data-cd]').forEach((el) => { cells[el.dataset.cd] = el; });
    const pad = (n) => String(n).padStart(2, '0');
    const set = (key, value) => {
      const el = cells[key];
      if (!el || el.textContent === value) return;
      el.textContent = value;
      // A soft drop-in for each change (not with reduced motion)
      if (!reduce && el.animate) el.animate([{ opacity: 0, transform: 'translateY(-0.25em)' }, { opacity: 1, transform: 'none' }], { duration: 420, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
    };
    const tick = () => {
      const left = Math.max(0, Math.floor((launch - Date.now()) / 1000));
      if (!left) { countdown.hidden = true; return false; }
      set('d', pad(Math.floor(left / 86400)));
      set('h', pad(Math.floor((left % 86400) / 3600)));
      set('m', pad(Math.floor((left % 3600) / 60)));
      set('s', pad(left % 60));
      return true;
    };
    if (!Number.isNaN(launch) && tick()) {
      // Line the ticks up with the clock's seconds
      window.setTimeout(() => { if (tick()) { const id = window.setInterval(() => { if (!tick()) window.clearInterval(id); }, 1000); } }, 1000 - (Date.now() % 1000));
    }
  }

  /* ---------------------------------------------------------- Add to calendar: an all-day entry for the launch day */
  root.addEventListener('click', (event) => {
    const link = event.target.closest('[data-mm-cs-cal]');
    if (!link) return;
    event.preventDefault();
    const day = root.dataset.calDate; // YYYYMMDD
    if (!/^\d{8}$/.test(day)) return;
    const next = new Date(Date.UTC(+day.slice(0, 4), +day.slice(4, 6) - 1, +day.slice(6, 8) + 1)).toISOString().slice(0, 10).replace(/-/g, '');
    const stamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d+/, '');
    const esc = (s) => String(s || '').replace(/([\\;,])/g, '\\$1');
    const url = root.dataset.calUrl || window.location.origin;
    const ics = [
      'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//mula-marga//coming-soon//EN', 'CALSCALE:GREGORIAN',
      'BEGIN:VEVENT',
      `UID:launch-${day}@${window.location.hostname}`,
      `DTSTAMP:${stamp}`,
      `DTSTART;VALUE=DATE:${day}`,
      `DTEND;VALUE=DATE:${next}`,
      `SUMMARY:${esc(root.dataset.calTitle)}`,
      `URL:${url}`,
      `DESCRIPTION:${esc(url)}`,
      'END:VEVENT', 'END:VCALENDAR',
    ].join('\r\n');
    const blobUrl = URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' }));
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = 'mula-marga-launch.ics';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.setTimeout(() => URL.revokeObjectURL(blobUrl), 4000);
  });

  // The cards: tick The MŪLA and/or The TARA, and the sign-up carries their tags.
  const interestButtons = [...root.querySelectorAll('[data-mm-cs-interest]')];
  const syncTags = () => {
    if (!tagsInput) return;
    const picked = interestButtons.filter((b) => b.getAttribute('aria-pressed') === 'true').map((b) => b.dataset.mmCsInterest).filter(Boolean);
    tagsInput.value = [tagsInput.dataset.base, ...picked].filter(Boolean).join(', ');
  };
  interestButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const on = button.getAttribute('aria-pressed') !== 'true';
      button.setAttribute('aria-pressed', String(on));
      syncTags();
      if (on) focusField();
    });
  });

  // The letter's "Join the list" goes back to the email field.
  root.querySelectorAll('[data-mm-cs-jump]').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (!email) return;
      event.preventDefault();
      focusField();
    });
  });

  const setError = (message) => {
    if (!errorEl || !email) return;
    errorEl.textContent = message || '';
    if (message) email.setAttribute('aria-invalid', 'true');
    else email.removeAttribute('aria-invalid');
  };
  if (email) email.addEventListener('input', () => { if (email.getAttribute('aria-invalid')) setError(''); });

  if (form && email) {
    form.addEventListener('submit', (event) => {
      const value = email.value.trim();
      if (!value) { event.preventDefault(); setError(errorEl.dataset.empty); email.focus(); return; }
      if (!email.checkValidity()) { event.preventDefault(); setError(errorEl.dataset.invalid); email.focus(); return; }
      setError('');
      // The normal form post, not a background request: Shopify's invisible spam check (hCaptcha) adds its
      // token on submit, and a post without it is refused ("Invalid CAPTCHA token"). The page comes back
      // with the thank-you, brought into view above.
      submit.setAttribute('aria-busy', 'true');
      submit.textContent = submit.dataset.sending || submit.textContent;
    });
  }


  /* ---------------------------------------------------------- The pair forms: line art draws itself
     As the main site's drawing (assets/mm-drawing.js): a faint sketch is there from the start, the pen traces the
     strokes one after another as fine lines and solid ink follows just behind; then a soft wash settles into the
     uppers and the brand marks on the insoles appear. Plays once on load, by time (not scroll). */
  const draw = root.querySelector('[data-mm-cs-draw]');
  const drawSvg = draw && draw.querySelector('svg');
  if (drawSvg) {
    const SVG_NS = 'http://www.w3.org/2000/svg';
    const lines = [...drawSvg.querySelectorAll('.mm-draw__lines path')];
    const linesGroup = drawSvg.querySelector('.mm-draw__lines');
    const d = lines.map((p) => p.getAttribute('d')).join(' ');
    // Each traced stroke gets a length of 1, so one dash value draws any of them.
    lines.forEach((p) => p.setAttribute('pathLength', '1'));

    const guide = document.createElementNS(SVG_NS, 'path');
    guide.setAttribute('class', 'mm-draw__guide');
    guide.setAttribute('fill-rule', 'evenodd');
    guide.setAttribute('d', d);
    linesGroup.parentNode.insertBefore(guide, linesGroup);

    const mask = document.createElementNS(SVG_NS, 'mask');
    mask.setAttribute('id', 'mm-cs-ink');
    mask.setAttribute('maskUnits', 'userSpaceOnUse');
    mask.setAttribute('maskContentUnits', 'userSpaceOnUse');
    ['x', 'y'].forEach((a) => mask.setAttribute(a, '-200'));
    ['width', 'height'].forEach((a) => mask.setAttribute(a, '2000'));
    const masks = lines.map((line) => {
      const m = document.createElementNS(SVG_NS, 'path');
      m.setAttribute('d', line.getAttribute('d'));
      m.setAttribute('pathLength', '1');
      m.setAttribute('class', 'mm-draw__mask');
      mask.appendChild(m);
      return m;
    });
    const defs = document.createElementNS(SVG_NS, 'defs');
    defs.appendChild(mask);
    drawSvg.insertBefore(defs, drawSvg.firstChild);

    const ink = document.createElementNS(SVG_NS, 'path');
    ink.setAttribute('class', 'mm-draw__ink');
    ink.setAttribute('fill-rule', 'evenodd');
    ink.setAttribute('d', d);
    ink.setAttribute('mask', 'url(#mm-cs-ink)');
    linesGroup.parentNode.insertBefore(ink, linesGroup.nextSibling);

    const range = (p, a, b) => clamp((p - a) / (b - a), 0, 1);
    const ease = (v) => (v < 0.5 ? 4 * v * v * v : 1 - Math.pow(-2 * v + 2, 3) / 2);
    const DRAW_END = 0.7;
    const STROKE_LEN = 0.3;
    const SOLID_LAG = 0.05;
    const render = (p) => {
      const spread = DRAW_END - STROKE_LEN - SOLID_LAG;
      lines.forEach((line, i) => {
        const start = (i / lines.length) * spread;
        line.style.strokeDashoffset = (1 - ease(range(p, start, start + STROKE_LEN))).toFixed(4);
        masks[i].style.strokeDashoffset = (1 - ease(range(p, start + SOLID_LAG, start + STROKE_LEN + SOLID_LAG))).toFixed(4);
      });
      linesGroup.style.opacity = (1 - range(p, DRAW_END - 0.02, DRAW_END + 0.1)).toFixed(3);
      draw.style.setProperty('--wash', ease(range(p, 0.72, 0.95)).toFixed(3));
      draw.style.setProperty('--brand', ease(range(p, 0.82, 1)).toFixed(3));
    };

    if (reduce || (window.Shopify && window.Shopify.designMode)) {
      render(1);
    } else {
      const PLAY_MS = 4600;
      render(0);
      window.setTimeout(() => {
        const t0 = performance.now();
        const step = (now) => {
          const p = clamp((now - t0) / PLAY_MS, 0, 1);
          render(p);
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }, 350);
    }
  }

  /* ---------------------------------------------------------- The making: each photo opens as it scrolls into view
     (once). Without the observer, with reduced motion or in the editor, everything simply shows. */
  const inEls = [...root.querySelectorAll('[data-mm-cs-in]')];
  if (inEls.length && !reduce && !(window.Shopify && window.Shopify.designMode) && 'IntersectionObserver' in window) {
    root.classList.add('has-in');
    const inIo = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        inIo.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });
    inEls.forEach((el) => inIo.observe(el));
  }

  /* ---------------------------------------------------------- The letter writes itself (as the About page)
     Each line waits for the previous one, starts when it scrolls into view, and fades in word by word; the
     wordmark signature is revealed last with a left-to-right wipe. Lines the reader scrolls past before they
     are written finish at once, so the letter never lags behind the reader. */
  const letter = root.querySelector('[data-mm-cs-letter]');
  const letterLines = letter ? [...letter.querySelectorAll('[data-line]')] : [];
  if (letterLines.length && !reduce && !(window.Shopify && window.Shopify.designMode) && 'IntersectionObserver' in window) {
    const WORD = 55;
    const PAUSE = 260;
    // Wrap every word in a span, keeping links, bold and line breaks intact.
    letterLines.forEach((line) => {
      let n = 0;
      const walker = document.createTreeWalker(line, NodeFilter.SHOW_TEXT, {
        acceptNode: (node) => (node.textContent.trim() && !node.parentElement.closest('svg') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT),
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((node) => {
        const frag = document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach((part) => {
          if (!part) return;
          if (/^\s+$/.test(part)) { frag.append(part); return; }
          const w = document.createElement('span');
          w.className = 'mm-cs-letter__w';
          w.textContent = part;
          w.style.setProperty('--d', `${n * WORD}ms`);
          n += 1;
          frag.append(w);
        });
        node.replaceWith(frag);
      });
      line.dataset.words = String(n);
      line.style.setProperty('--ink', `${n * WORD + 200}ms`);
    });
    letter.classList.add('is-armed');

    let queue = 0;
    let busy = false;
    let timer = 0;
    const pump = () => {
      if (busy) return;
      const line = letterLines[queue];
      if (!line || line.dataset.seen !== '1') return;
      busy = true;
      line.classList.add('is-written');
      let duration = Number(line.dataset.words || 0) * WORD;
      if (line.hasAttribute('data-signature')) duration += 1100;
      timer = window.setTimeout(() => {
        queue += 1;
        busy = false;
        if (queue >= letterLines.length) letter.classList.add('is-done');
        pump();
      }, duration + PAUSE);
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.dataset.seen = '1';
        io.unobserve(entry.target);
      });
      catchUp();
      pump();
    }, { rootMargin: '0px 0px -18% 0px', threshold: 0 });
    // Lines the reader has passed (bottom above 25% of the viewport) finish instantly; the queue goes on from there.
    let catchRaf = 0;
    const onScroll = () => {
      if (catchRaf) return;
      catchRaf = requestAnimationFrame(() => { catchRaf = 0; catchUp(); });
    };
    function catchUp() {
      if (letter.classList.contains('is-done')) { window.removeEventListener('scroll', onScroll); return; }
      const limit = window.innerHeight * 0.25;
      let passed = -1;
      letterLines.forEach((line, i) => { if (line.getBoundingClientRect().bottom < limit) passed = i; });
      if (passed < queue) return;
      window.clearTimeout(timer);
      for (let i = queue; i <= passed; i++) {
        letterLines[i].classList.add('is-instant', 'is-written');
        letterLines[i].dataset.seen = '1';
        io.unobserve(letterLines[i]);
      }
      queue = passed + 1;
      busy = false;
      if (queue >= letterLines.length) letter.classList.add('is-done');
      pump();
    }
    letterLines.forEach((line) => io.observe(line));
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (reduce) return;

  /* ---------------------------------------------------------- Pointer depth: the drawing drifts a little with the pointer */
  const depthEls = [...root.querySelectorAll('[data-depth]')];
  let targetX = 0;
  let targetY = 0;
  let x = 0;
  let y = 0;
  let running = false;
  function frame() {
    x += (targetX - x) * 0.07;
    y += (targetY - y) * 0.07;
    for (const el of depthEls) {
      const depth = parseFloat(el.dataset.depth) || 0;
      el.style.setProperty('--px', `${(x * depth * 22).toFixed(2)}px`);
      el.style.setProperty('--py', `${(y * depth * 16).toFixed(2)}px`);
    }
    // Rest once the layers arrive; the next pointer move wakes the loop again.
    if (Math.abs(targetX - x) < 0.0008 && Math.abs(targetY - y) < 0.0008) { running = false; return; }
    requestAnimationFrame(frame);
  }
  const wake = () => {
    if (running) return;
    running = true;
    requestAnimationFrame(frame);
  };
  if (finePointer && depthEls.length) {
    window.addEventListener('pointermove', (event) => {
      targetX = event.clientX / window.innerWidth - 0.5;
      targetY = event.clientY / window.innerHeight - 0.5;
      wake();
    }, { passive: true });
    document.documentElement.addEventListener('pointerleave', () => { targetX = 0; targetY = 0; wake(); });
  }

  /* ---------------------------------------------------------- Frosted cards: tilt and catch the light */
  if (finePointer) {
    interestButtons.forEach((card) => {
      card.addEventListener('pointermove', (event) => {
        const r = card.getBoundingClientRect();
        const px = (event.clientX - r.left) / r.width;
        const py = (event.clientY - r.top) / r.height;
        card.classList.add('is-tilting');
        card.style.setProperty('--rx', `${((0.5 - py) * 7).toFixed(2)}deg`);
        card.style.setProperty('--ry', `${((px - 0.5) * 9).toFixed(2)}deg`);
        card.style.setProperty('--mx', `${(px * 100).toFixed(1)}%`);
        card.style.setProperty('--my', `${(py * 100).toFixed(1)}%`);
      });
      card.addEventListener('pointerleave', () => {
        card.classList.remove('is-tilting');
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
        card.style.setProperty('--mx', '50%');
        card.style.setProperty('--my', '30%');
      });
    });
  }
})();
